import { defineStore } from "pinia";
//import fileAppConfig from "@/assets/config/app-conf-dev.json";
import fileAppConfig from "@/assets/config/app-conf-qa.json";
//import fileAppConfig from "@/assets/config/app-conf-prd.json";
import { IAppSystemSettings } from "../services/sys/AppSystemSettingsService";
const appConfig = {...fileAppConfig};
appConfig.version = process.env.VUE_APP_VERSION;
//si en los stores ocurre algun error la aplicacion simplemente falla
//no se muestra nada ni en console ni en el explorador al menos usando electron.
export const useMainStore = defineStore('mainstore', 
{
  state: () => {
      return {
        appConfig:appConfig,
        appLanguage:'',
        appSettings:[]
        //sesionApp: new SesionApp(),
      }
    },
  getters: 
  {
    getAppSettings : (state):IAppSystemSettings[] => {return  state.appSettings as IAppSystemSettings[]},
    getAppLanguage:(state):string => {return state.appLanguage;},
    getAppConfig: state => state.appConfig
  },
  actions:
  {
    setAppSettings (settings: IAppSystemSettings[]|any)
    {
      this.appSettings = settings;
    },
    setAppLanguage (lang:string)
    {
      this.appLanguage = lang;
    },
  }
});